var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9854 6.33829C12.9854 6.39557 13.0238 6.44483 13.0787 6.45973C13.5182 6.5783 13.9188 6.75646 14.2804 7.01767C15.1028 7.61055 15.5817 8.42684 15.8175 9.40008C15.9205 9.82455 15.9554 10.2559 15.9543 10.6918C15.952 11.7201 15.9549 12.7483 15.9514 13.7771C15.9514 13.8653 15.9863 13.9501 16.0498 14.012C16.3108 14.2674 16.5735 14.5218 16.8224 14.7887C17.1669 15.1588 16.9843 15.7522 16.4979 15.8742C16.4424 15.888 16.3852 15.892 16.3285 15.892C13.4501 15.8926 10.5717 15.8926 7.69327 15.8926C7.38311 15.8926 7.15535 15.7522 7.05292 15.4876C6.94476 15.2063 7.0037 14.9571 7.21773 14.744C7.46379 14.4994 7.70586 14.2514 7.95421 14.0091C8.01258 13.9524 8.04577 13.8745 8.0452 13.7926C8.04234 12.7391 8.0412 11.6857 8.04406 10.6317C8.04635 9.78903 8.20886 8.98306 8.62661 8.24238C9.13763 7.33788 9.89243 6.74213 10.8967 6.47118C10.9797 6.44884 11.0186 6.41848 11.0146 6.32454C11.0083 6.17904 11.0095 6.03182 11.0226 5.88632C11.0707 5.3576 11.513 4.98125 12.0561 5.00072C12.5597 5.01848 12.9729 5.4441 12.9843 5.95907C12.9877 6.0828 12.986 6.20711 12.9854 6.33829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6914 16.6895C10.6914 17.4129 11.2774 17.9995 12.0001 17.9995C12.7229 17.9995 13.3089 17.4129 13.3089 16.6895H10.6914Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.d87ac9342204e8382cda3d12866b3e1f.svg";
export { ForwardRef as ReactComponent };